import React from "react";

/**
 * Highlights the `highlight` text within the `text` string.
 * Case-insensitive.
 */
const HighlightText = ({ text, highlight, className = "" }) => {
    if (!highlight || !text || typeof text !== 'string') {
        return <span data-slot="highlight-text" className={className}>{text}</span>;
    }

    // Escape special regex characters in the highlight string
    const escapeRegExp = (string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    const parts = text.split(new RegExp(`(${escapeRegExp(highlight)})`, "gi"));

    return (
        <span data-slot="highlight-text" className={className}>
            {parts.map((part, i) =>
                part.toLowerCase() === highlight.toLowerCase() ? (
                    <span key={i} className="rounded-[var(--ds-radius-highlight)] bg-primary/10 px-[var(--ds-space-half)] font-bold text-primary">
                        {part}
                    </span>
                ) : (
                    part
                )
            )}
        </span>
    );
};

export default HighlightText;
